import {
	Box,
	Container,
	Divider,
	makeStyles,
	Typography
} from '@material-ui/core';
import React from 'react';
import Page from 'src/components/Page';
import Tabs from './Tabs';
// import ProfileDetails from './ProfileDetails';

const useStyles = makeStyles((theme) => ({
	root: {
		// backgroundColor: theme.palette.background.dark,
		minHeight: '100%',
		paddingBottom: theme.spacing(3),
		paddingTop: theme.spacing(3)
	},
	'@media screen': {
		root: {
			backgroundColor: '#F4F6F8'
		}
	},

	'@media print': {
		root: {
			backgroundColor: 'white !important'
		}
	}
}));

const Reports = () => {
	const classes = useStyles();

	return (
		<Page
			className={classes.root}
			title="Reports"
		>
			<Container id={'printthis'} maxWidth={false} style={{ paddingBottom: 20 }}>
				<Box mt={3} >
					<Typography variant="h3" gutterBottom>
						Reports
					</Typography>
					<Divider />
				</Box>
				<Box mt={3}>
					<Tabs />
				</Box>
			</Container>
		</Page>
	);
};

export default Reports;
